<template lang="pug">
  include /mixins.pug
  +b.place-range.relative(v-if='sliderRangeActive')
    row(
      :justify="['around']"
    )
      cell(
        align='center'
        :cols="['7 8-md auto-xl']"
      )
        row
          cell(align='center')
            +b.SPAN.decorate-range.ds-caption.--size-10.--color-gray-light-another {{ _('min')}}
          cell(
            align='center'
            :cols="['auto']"
            class='grow'
          )
            range-slider(
              v-model='values'
              :min='price.min'
              :max='price.max'
              :height='5'
              @change='debounceAction($event)'
            )
              template(#process='{ start, end, style, index }')
                .vue-slider-process.custom-process(
                  :style="[style]"
                )
              template(#dot='')
                +b.custom-dot
          cell(align='center')
            +b.SPAN.decorate-range.ds-caption.--size-10.--color-gray-light-another {{ _('max')}}
      cell(
        align='center'
        :cols="['4 4-md auto-xl']"
      )
        +b.place-for-prices
          +b.SPAN.ds-caption.--size.--color-blue-medium.--size-15.--weight-bold {{ values[0] }}
          +b.SPAN.decoration.ds-caption.--size.--color-blue-medium.--size-15.--weight-bold -
          +b.SPAN.ds-caption.--size.--color-blue-medium.--size-15.--weight-bold {{ values[1] }}
    +b.label-for-range
      +e.SPAN.text.ds-caption.--size-12.--color-gray-light.--weight-bold {{ _('Хранение тонн')}}
</template>

<script>
import { debounce } from 'vue-debounce'

export default {
  props: {
    range: Boolean,
    value: {},
    filter: {},
    unit: {},
    sliderConfig: {},
  },
  data() {
    return {
      debounceAction: null,
      price: {
        min: 0,
        max: 1,
      },
      sliderRangeActive: false,
      values: [0, 0],
    }
  },
  mounted() {
    const delay = 2000
    this.debounceAction = debounce(() => {
      this.submit()
    }, delay)
  },
  watch: {
    range() {
      this.$set(this.values, 0, this.filter.min)
      this.$set(this.values, 1, this.filter.max)
    },
    filter: {
      immediate: true,
      deep: true,
      handler(nval) {
        this.$set(this.price, 'min', nval.min)
        this.$set(this.price, 'max', nval.max)
        this.$set(this.values, 0, nval.min)
        this.$set(this.values, 1, nval.max)
        if (nval.max) {
          this.sliderRangeActive = true
        }
      },
    },
  },
  methods: {
    submit() {
      this.$emit('input', this.values)
    },
  },
}
</script>
